/**
 * @author Karl Jones
 * @email karljones@live.ie
 * @create date 2022-12-10 20:43:41
 * @modify date 2022-12-10 20:43:41
 * @desc this sets out the template that is used to display content to the user, this will hold all content and display the header
 */

import { Suspense } from 'react'
import { Outlet } from "react-router-dom";

import announcementBarData from '../../data/announcement_bar_data.json';
import AnnouncementBar from '../common/AnnouncementBar';
import Header from "../common/header/Header"
import LinearProgress from '@mui/material/LinearProgress';
import Footer from '../common/footer/Footer';

interface ILayout {
    tab: number;
    setTab: (tab: number) => void;
}

const Layout = ({ tab, setTab }: ILayout) => {
    return (
        <div>
            <div style={{ minHeight: 'calc(100vh - 100px)' }}>
                {announcementBarData.open &&
                    <AnnouncementBar message={announcementBarData.message} learnMore={announcementBarData.learnMore} />
                }

                <Header tab={tab} setTab={setTab} />

                <Suspense fallback={<LinearProgress />}>
                    <Outlet />
                </Suspense>
            </div>

            <Footer />
        </div>
    )
}

export default Layout;